var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType1Connector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 12,
    r: 10.5,
    stroke: "param(outline) #fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 12,
    r: 7.5,
    stroke: "param(outline) #fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2877,
    cy: 15.2275,
    r: 1.5,
    fill: "param(outline) #fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.83331,
    cy: 9.5,
    r: 1.5,
    fill: "param(outline) #fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8333,
    cy: 9.5,
    r: 1.5,
    fill: "param(outline) #fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1515,
    cy: 13.8182,
    r: 0.818182,
    fill: "param(outline) #fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.15149,
    cy: 13.8182,
    r: 0.818182,
    fill: "param(outline) #fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType1Connector);
export default __webpack_public_path__ + "static/media/type1_connector.751511133372e1a0176e0aa19f4ca06c.svg";
export { ForwardRef as ReactComponent };